import { SubmissionError } from 'redux-form';
import { goToElement } from '../../utils/goToElement';
import { FIELDS_FOR_VALIDATE } from './constants';

export const transformToValidationErrors = errors => {
	if (!errors || typeof errors !== 'object') return {};

	const firstField = Object.keys(errors)[0];
	goToElement(`company.${firstField}`);

	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (!prev.company) {
			prev.company = {};
		}
		prev.company[key] = error;
		return prev;
	}, {});
};

export const validate = values => {
	FIELDS_FOR_VALIDATE.forEach(key => {
		if (!values?.company[key]) {
			const input = `company.${key}`;
			goToElement(input);
			throw new SubmissionError({ company: { [key]: 'Заполните это поле' } });
		}
	});
};
